import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";
import {Link} from "react-router-dom";
import OcenyService from "../OcenyService";

export default class OcenyTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedRow: null,
            isLoading: false,
            plik: null,
        };
        this.onExpand = this.onExpand.bind(this)
        this.isExpandableRow = this.isExpandableRow.bind(this)
        this.expandComponent = this.expandComponent.bind(this)
    }

    componentDidMount() {
    }


    renderGwiazdki(cell, row) {
        if (cell == 0 || cell == 1 || cell == 2 || cell == 3 || cell == 4 || cell == 5) {
            let tabpelne = []
            let tabpuste = []

            for (let i = 0; i < parseInt(cell); i++) {
                tabpelne.push('pelne')
            }
            for (let i = 0; i < (5 - parseInt(cell)); i++) {
                tabpuste.push('puste')
            }
            return (
                <div>
                    {
                        tabpelne.map(item => {
                            return <i className={'fa fa-star'} style={{color: 'orange'}}></i>
                        })}
                    {
                        tabpuste.map(item => {
                            return <i className={'fa fa-star-o'} style={{color: 'orange'}}></i>
                        })}
                </div>
            )
        }
        else if (cell === null) return 'null'
    }

    expandComponent(row) {
        return <div style={{borderBottom: '3px solid #83c33a', paddingBottom: '5px'}}>
            <div className={'well well-sm'} style={{marginBottom: '5px'}}>
                <h4>Uwaga:</h4>
                <div>{row.uwagi}</div>
                {
                    Boolean(this.state.isLoading) ?
                        <div id={'smallLoader'}>
                            <i className={'fa fa-circle-o-notch fa-spin'}></i>
                            <div>Trwa ładowanie pliku...</div>
                        </div>
                        :
                        <div>
                            {Boolean(this.state.plik) ?
                                this.state.plik.map(item => {
                                    return (<div>
                                            <h4>Plik do uwagi: <span>{item.nazwa}</span></h4>
                                            <div>
                                                <img src={'data:image/jpg;base64,' + item.dane}
                                                     style={{maxWidth: '90%'}} className={'thumbnail'}/>
                                            </div>
                                        </div>

                                    )
                                })
                                :
                                ''
                            }
                        </div>
                }
            </div>
        </div>

    }

    expandColumnComponent({isExpandableRow, isExpanded}) {
        let content = '';

        if (isExpandableRow) {
            content = (isExpanded ?
                    (<i style={{display: "block", textAlign: "center"}} className='fa fa-lg fa-caret-up'></i>)
                    :
                    (<i style={{display: "block", textAlign: "center"}} className='fa fa-lg fa-caret-down'></i>)
            )
        } else {
            content = ' ';
        }
        return (
            <div> {content} </div>
        );
    }

    isExpandableRow(row) {
        if (Boolean(this.state.expandedRow)) {
            return this.state.expandedRow === row.idOc
        } else
            return (Boolean(row.uwagi) || Boolean(row.idPlik))
    }

    onExpand(cell, isExpanded) {
        if (isExpanded) {
            this.setState({
                expandedRow: cell,
                isLoading: true,
            })
            OcenyService.pobierzPlikDoOceny(cell).then(function (response) {
                if (Boolean(response)) {
                    if (response.data) {
                        this.setState({
                            plik: response.data,
                            isLoading: false
                        })
                    } else {
                        this.setState({
                            isLoading: false
                        })
                    }
                } else {
                    this.setState({
                        isLoading: false
                    })
                }
            }.bind(this))
        }
        else {
            this.setState({
                expandedRow: null,
                isLoading: false,
                plik: null
            })
        }
    }

    render() {

        let ocenypoziom = {
            1: 1,
            2: 2,
            3: 3,
            4: 4,
            5: 5,
        }

        const options = {
            sizePerPage: 15,  // Showing 30 for the size per page as default
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów',
            expandBy: 'column',
            onExpand: this.onExpand,
        };
        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                                expandableRow={this.isExpandableRow}
                                expandComponent={this.expandComponent}
                                expandColumnOptions={{
                                    expandColumnVisible: true,
                                    expandColumnComponent: this.expandColumnComponent,
                                    columnWidth: 30,
                                }}
                >

                    <TableHeaderColumn dataField='idOc' isKey hidden={false}
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} expandable={false}
                    >ID Oceny</TableHeaderColumn>
                    <TableHeaderColumn dataField='klient'
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4} expandable={false}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                       dataFormat={(cell, row) => {
                                           return (<Link to={'/zarzadzanie-klientami/klient/' + row.idKl}
                                                         target={'_blank'}
                                                         title={'Kliknij, aby przejść do strony klienta'}>
                                               {
                                                   Boolean(row.imieKl) && Boolean(row.nazKl) ?
                                                       cell
                                                       :
                                                       "Klient z nieuzupełnionymi danymi"
                                               }
                                           </Link>)
                                       }}
                    >Klient</TableHeaderColumn>
                    <TableHeaderColumn dataField='data'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={false}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Data</TableHeaderColumn>
                    <TableHeaderColumn dataField='godz'
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} expandable={false}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                       dataFormat={(cell, row) => {
                                           return DateAndTimeFormat.formatHHMM(cell)
                                       }}
                    >Godz.</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazTr'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} expandable={false}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Trasa</TableHeaderColumn>
                    <TableHeaderColumn dataField='idKu'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={false}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Kurs</TableHeaderColumn>
                    <TableHeaderColumn dataField='kierowca'
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4} expandable={false}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Kierowca</TableHeaderColumn>
                    <TableHeaderColumn dataField='ocena1'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={false}
                                       filter={{type: 'SelectFilter', options: ocenypoziom, selectText: ''}} formatExtraData={ocenypoziom}
                                       dataFormat={this.renderGwiazdki}
                    >Czystość</TableHeaderColumn>
                    <TableHeaderColumn dataField='ocena2'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={false}
                                       filter={{type: 'SelectFilter', options: ocenypoziom, selectText: ''}} formatExtraData={ocenypoziom}
                                       dataFormat={this.renderGwiazdki}
                    >Komfort</TableHeaderColumn>
                    <TableHeaderColumn dataField='ocena3'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={false}
                                       filter={{type: 'SelectFilter', options: ocenypoziom, selectText: ''}} formatExtraData={ocenypoziom}
                                       dataFormat={this.renderGwiazdki}
                    >Kierowca</TableHeaderColumn>
                    <TableHeaderColumn dataField='ocena4'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={false}
                                       filter={{type: 'SelectFilter', options: ocenypoziom, selectText: ''}} formatExtraData={ocenypoziom}
                                       dataFormat={this.renderGwiazdki}
                    >Punktualność</TableHeaderColumn>

                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/oceny/components/OcenyTable.js